import type {
  CobrancaReguaPasso, UpsertCobrancaReguaPassoCommand, RunReguaResult,
} from '@/domain/model/CobrancaRegua';
import type { CobrancaReguaGateway } from '@/application/port/out/CobrancaReguaGateway';
import type {
  ListCobrancaReguaPassosUseCase, CreateCobrancaReguaPassoUseCase,
  UpdateCobrancaReguaPassoUseCase, DeleteCobrancaReguaPassoUseCase, RunReguaCobrancaUseCase,
} from '@/application/port/in/CobrancaReguaUseCase';

export class ListCobrancaReguaPassos implements ListCobrancaReguaPassosUseCase {
  constructor(private readonly g: CobrancaReguaGateway) {}
  execute(): Promise<CobrancaReguaPasso[]> { return this.g.list(); }
}
export class CreateCobrancaReguaPasso implements CreateCobrancaReguaPassoUseCase {
  constructor(private readonly g: CobrancaReguaGateway) {}
  execute(cmd: UpsertCobrancaReguaPassoCommand): Promise<CobrancaReguaPasso> { return this.g.create(cmd); }
}
export class UpdateCobrancaReguaPasso implements UpdateCobrancaReguaPassoUseCase {
  constructor(private readonly g: CobrancaReguaGateway) {}
  execute(id: string, cmd: UpsertCobrancaReguaPassoCommand): Promise<CobrancaReguaPasso> { return this.g.update(id, cmd); }
}
export class DeleteCobrancaReguaPasso implements DeleteCobrancaReguaPassoUseCase {
  constructor(private readonly g: CobrancaReguaGateway) {}
  execute(id: string): Promise<void> { return this.g.delete(id); }
}
export class RunReguaCobranca implements RunReguaCobrancaUseCase {
  constructor(private readonly g: CobrancaReguaGateway) {}
  execute(): Promise<RunReguaResult> { return this.g.run(); }
}
